import { TextField, styled } from '@mui/material';

export const ChallengeInput = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.common.white,
  },
}));
